import { render, staticRenderFns } from "./InfectionCauses.vue?vue&type=template&id=3db0ec6c"
import script from "./InfectionCauses.vue?vue&type=script&lang=js"
export * from "./InfectionCauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports